import { useEffect } from "react";
import { useMerchantApiMutation } from "../../hooks";
import {
  IResolveBankAccountRequest,
  IResolveBankAccountResponse,
} from "../../interfaces-and-types";
import { View } from "./View";

export interface IBankAccountResolverProps {
  country: string;
  currency: string;
  accountNumber: string;
  bankCode: string;

  isBankAccountResolved: boolean;
  setBankAccountResolved: (isResolved: boolean) => void;
  setResolvedBankAccountDetails?: (
    resolvedDetails: IResolveBankAccountResponse
  ) => void;
}

export interface IBankAccountResolverViewProps {
  isLoading: boolean;
  isError: boolean;
  isBankAccountResolved: boolean;
  accountName: string | null;
  errorMessage: string | null;
}

export const BankAccountResolver = (props: IBankAccountResolverProps) => {
  const {
    accountNumber: account_number,
    bankCode: bank_code,
    country,
    currency,
    isBankAccountResolved,
    setBankAccountResolved,
    setResolvedBankAccountDetails,
  } = props;

  // const {
  //   isLoading: isLoading,
  //   isSuccess: isSuccess,
  //   isError: isError,
  //   data: bankAccountDetails,
  //   error,
  // } = useMerchantApiQueryWithParams<
  //   IResolveBankAccountRequest,
  //   IResolveBankAccountResponse
  // >(["resolveBankAccount", { account_number, bank_code, country, currency }], {
  //   enabled:
  //     !!account_number &&
  //     !!bank_code &&
  //     !!country &&
  //     !!currency &&
  //     account_number.length >= 10, // TODO: use country codes to determine length of acc number
  // });

  const {
    isLoading,
    isSuccess,
    isError,
    data: bankAccountDetailsApiResponse,
    mutate: resolveBankAccount,
  } = useMerchantApiMutation<
    IResolveBankAccountRequest,
    IResolveBankAccountResponse
  >("resolveBankAccount", null, {
    ignoreActivityBlocker: true,
  }).usePostMutation;

  useEffect(() => {
    // if (isBankAccountResolved) {
    setBankAccountResolved(false);
    // }
  }, [account_number, bank_code, country, currency]);

  useEffect(() => {
    if (isSuccess) {
      setBankAccountResolved(true);
      setResolvedBankAccountDetails &&
        setResolvedBankAccountDetails(bankAccountDetailsApiResponse.data);
    }
  }, [isSuccess]);

  const accountInfoSupplied =
    !!account_number &&
    !!bank_code &&
    !!country &&
    !!currency &&
    account_number.length >= 10; // TODO: use country codes to determine length of acc number

  useEffect(() => {
    if (accountInfoSupplied && !isBankAccountResolved)
      resolveBankAccount({
        account_number,
        bank_code,
        country,
        currency,
      });
  }, [
    isBankAccountResolved,
    accountInfoSupplied,
    account_number,
    bank_code,
    country,
    currency,
  ]);

  // const { message: errorMessage = "Account number could not be verified..." } =
  //   (error as any)?.data;

  return (
    <View
      isLoading={isLoading}
      isError={isError}
      isBankAccountResolved={isBankAccountResolved}
      accountName={bankAccountDetailsApiResponse?.data.account_name ?? null}
      errorMessage={"Account number could not be verified..."}
    />
  );
};
